export default {
    methods: {
        changeDialCode(model, key, value) {
            if (typeof value === 'object') {
                model[key] = value.dial_code;
                model[key + '_country'] = value.value;
                model[key + '_country_code'] = value.code;
            }
        }
    }
}